export const SectionData = {
  "sectionData_1": "Diamond, Gemstone, and Other Studded Jewellery",
  "sectionData_2": "Gold and Gold CZ Studded Jewellery",
  "sectionData_3": "Silver Jewellery, Artifacts & Gifting Items",
  "sectionData_4": "Laboratory and Education",
  "sectionData_5": "Lab Grown Diamonds (Loose)",
  "sectionData_6": "Lab Grown Jewellery",
  "sectionData_7": "International Jewellery",
  "sectionData_8": "Loose Stones Colour Stones",
  "sectionData_9": "The Select Club",
  "sectionData_10": "Loose Stones Diamonds",
  "sectionData_11": "Allied",
  "sectionData_12": "Machinery",
  "sectionData_13": "International Machinery",
  "sectionData_14": "International Loose",
  "sectionData_16": "Loose Gem Stones (Pearls)",
};

export const SectionDataColor = {
  sectionData_1: "#5488a5",
  sectionData_2: "#bb8a44",
  sectionData_3: "#3f4040",
  sectionData_4: "#6f6d99",
  sectionData_5: "#48776a",
  sectionData_6: "#405840",
  sectionData_7: "#b3776d",
  sectionData_8: "#af2723",
  sectionData_9: "#ff0afe",
  sectionData_10: "#643358",
  sectionData_11: "#23454a",
  sectionData_12: "#556468",
  sectionData_13: "#c60000",
  sectionData_14: "#c60000",
  sectionData_15: "#ff0002",
};